const handleMobileNavTabs = () => {
  $('.tabs__nav').on('click', function() {
    const $this = $(this);
    const mobileBreakpoint = 767;
    const isMobileBreakpoint = $(window).innerWidth() <= mobileBreakpoint;

    if (! isMobileBreakpoint) {
      return;
    }

    $this.toggleClass('is-open');
  });
}

handleMobileNavTabs();
